import type React from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';

import InputError from '../InputError';
import InputHelp from '../InputHelp';
import { Input, Label, LabelText, Wrapper } from './wrapper';

export type InputCheckboxProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  id: string;
  children?: React.ReactNode;
  inputHelp?: string;
  textTone?: 'alt';
  textSize?: 'xsmall' | 'small';
  error?: string;
  valignCenter?: boolean; // Vertically align checkbox and text center
  extraSpacing?: boolean; // Add extra spacing between checkbox and text
  register?: UseFormRegisterReturn;
  color?: string;
};

const InputCheckbox = ({
  children,
  inputHelp,
  textTone,
  textSize,
  error,
  valignCenter,
  extraSpacing,
  register,
  ...props
}: Omit<InputCheckboxProps, 'ref'>) => {
  const { id } = props;
  return (
    <Wrapper aria-labelledby={id ? `${id}-label` : undefined} $error={!!error} $textSize={textSize}>
      <Input {...props} {...register} />
      <Label id={`${id}-label`} htmlFor={id} $valignCenter={valignCenter}>
        {children && (
          <LabelText $extraSpacing={extraSpacing} $textTone={textTone}>
            {children}
            {inputHelp && <InputHelp disabled={props.disabled}>{inputHelp}</InputHelp>}
            {error && <InputError>{error}</InputError>}
          </LabelText>
        )}
      </Label>
    </Wrapper>
  );
};

export default InputCheckbox;
